// removed by extract-text-webpack-plugin
module.exports = {"list":"list__1iK31"};


//////////////////
// WEBPACK FOOTER
// ./components/Rules/style.css
// module id = krSn
// module chunks = 0